import { MessageCircle } from "lucide-react";
import { WHATSAPP_TRAINING_HREF } from "../lib/contact";

export default function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP_TRAINING_HREF}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp ile iletişime geç"
      data-testid="floating-whatsapp"
      className="fixed bottom-4 right-4 sm:bottom-5 sm:right-5 z-40 inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full shadow-lg transition-transform hover:scale-105"
      style={{ background: "#25D366", color: "white" }}
    >
      <MessageCircle size={24} />
    </a>
  );
}
